import React from 'react';
import ContextMenu from './ContextMenu';
import { buildTableMenuItems } from '../../helpers/tableHelpers';

export default function ContextMenuTables({
  editor,
  anchorRef = null,
  isOpen = false,
  diffMode = 'write',
  currentUserId = null,
  onClose = () => {}
}) {
  if (!isOpen) return null;

  const items = buildTableMenuItems(editor, onClose, anchorRef?.current || null, {
    diffMode,
    currentUserId
  });

  return (
    <ContextMenu
      items={items}
      triggerRef={anchorRef}
      placement="bottom"
      menuClass="contextMenuTables__menu"
      onClose={onClose}
    />
  );
}
